import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities'

class AnalyticsRepository {

    constructor() {
        this.basePath = store.state.analyticsPath;
    }

    allFeatures() {
        let response = axios.get(`${this.basePath}/getFeatures`);
        response = verifyAuth(response) 
        return response;
    }

    votesByUser(userId) {
        let response = axios.get(`${this.basePath}/getVotesByUser?userId=${userId}`);
        response = verifyAuth(response) 
        return response;
    }

    voteForFeature(voteData) {
        let response = axios.post(`${this.basePath}/voteForFeature`, voteData);
        response = verifyAuth(response) 
        return response;
    }

    proposeCustomFeature(featureData) {
        let response = axios.post(`${this.basePath}/proposeCustomFeature`, featureData);
        response = verifyAuth(response) 
        return response;
    }
}

export default new AnalyticsRepository();
